import {
  ResponsiveSanityImageProps,
  SanityImageRatio,
  ResponsiveSanityImage
} from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./BrochureImage.module.scss";

interface BrochureImageProps {
  image?: ResponsiveSanityImageProps["image"];
}

const BrochureImage: React.FC<React.PropsWithChildren<BrochureImageProps>> = ({
  image
}) => {
  return (
    <SanityImageRatio
      image={image}
      ratio="auto"
      className={styles.brochureImage}
    >
      <ResponsiveSanityImage
        image={image}
        defaultWidth={360}
        defaultHeight={300}
        fit="original"
      />
    </SanityImageRatio>
  );
};

export default BrochureImage;
